import IdentityDropzone from './identity-dropzone';

export default IdentityDropzone;
